<template>
  <div class="app-container">
    <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="68px">
      <el-row>
       <el-form-item label="抽奖人id">
              <el-input v-model="queryParams.openid" placeholder="请输入抽奖人id" clearable  size="small" />
            </el-form-item>
           <!--   <el-form-item label="预留电话">
              <el-input v-model="queryParams.type_phone" placeholder="请输入电话号码" clearable  size="small" />
            </el-form-item> -->

        <!-- <el-form-item label="伴奏指法">
              <el-input v-model="queryParams.qumu_zhifa" placeholder="多个链接用英文逗号“,”分隔" clearable size="small" />
            </el-form-item> -->


      </el-row>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini"
          @click="handleQuery">查询</el-button>
        <!-- <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button> -->
      </el-form-item>
    </el-form>

    <div class="gap"></div>
    <!-- <div style="text-align: left; padding-left: 20px;">
      <el-button type="primary" icon="el-icon-add" :loading="loading" size="mini" @click="handleAdd">新增</el-button>

    </div> -->
    <el-table v-loading="loading" :data="list">
      <el-table-column label="抽奖人id" align="center" label-class-name='title'  prop="openid" />
      <el-table-column label="抽奖券编号" align="center" label-class-name='title' prop="choujiangquan_id" />
      <el-table-column label="抽奖券名称" align="center" label-class-name='title' prop="choujiangquan_name" />
      <!-- <el-table-column label="可用会员等级" align="center" :formatter="levelTrans" label-class-name='title' prop="choujiangquan_level" /> -->
      <el-table-column label="抽奖券描述" align="center" label-class-name='title' prop="choujiangquan_desc" />
      <el-table-column label="抽奖时间" align="center" label-class-name='title' prop="choujiang_record_time" />
      <!-- <el-table-column label="抽奖券状态" align="center"  :formatter="stateTrans" label-class-name='title' prop="choujiangquan_state" /> -->
      <!-- <el-table-column label="操作" align="center" width="200" label-class-name='title'
        class-name="small-padding fixed-width">
        <template slot-scope="scope"> -->
          <!-- <el-button class="inspect-button" size="mini" type="primary" icon="el-icon-edit"
            @click="handleUpdate(scope.row)">修改</el-button> -->
          <!-- <el-button class="inspect-button" size="mini" type="danger" icon="el-icon-delete"
            @click="handleDelete(scope.row)">删除</el-button> -->
          <!-- <el-button v-if="scope.row.judge == '0' && scope.row.state == '1'" class="inspect-button"
                     size="mini"
                     type="primary"
                     @click="handleJudge(scope.row)">评价</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-view"
                     @click="handleView(scope.row)">查看</el-button>
 
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-delete"
                     @click="handleDelete(scope.row.id)">删除</el-button> -->
        <!-- </template>
      </el-table-column> -->


    </el-table>
    <el-pagination v-show="total > 0" :total="total" @current-change="getList" @prev-click='getList'
      @next-click="getList" />
    <!-- 操作日志详细 -->
    <el-dialog title="抽奖券新增" :visible.sync="open" :close-on-click-modal="false" width="500px" append-to-body>
      <el-form ref="form" :model="form" label-width="100px" size="mini">
        <el-row>
          <el-col :span="24">
            <el-form-item label="抽奖券名称">
              <el-input v-model="form.choujiangquan_name" placeholder="请输入抽奖券名称" clearable size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item label="抽奖率">
              <el-input v-model="form.choujiangquan_discount" placeholder="请输入抽奖券率" clearable size="small" />
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item label="可用会员等级">
              <el-select style="width: 100%;" v-model="form.choujiangquan_level" placeholder="请选择">
                <el-option v-for="item in vipLevel" :key="item.choujiangquan_level" :label="item.level_name" :value="item.choujiangquan_level">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->



        <el-row>
          <el-col :span="24">
            <el-form-item label="抽奖券描述">
              <el-input v-model="form.choujiangquan_desc" placeholder="请输入抽奖券描述" clearable size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="抽奖券数量">
              <el-input v-model="form.choujiangquan_num" placeholder="请输入抽奖券数量" clearable size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="抽奖券状态">
              <el-select style="width: 100%;" v-model="form.choujiangquan_state" placeholder="请选择">
                <el-option v-for="item in choujiangquanState" :key="item.choujiangquan_state" :label="item.choujiangquan_name" :value="item.choujiangquan_state">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="open = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>



</template>

<script>
import config from '../../config/config'
import { choujiangquanAdd, choujiangRecordList, choujiangquanDelete, choujiangquanUpdate } from '../api/choujiangquan/index';
import { Notification, MessageBox, Message, Link } from "element-ui";
export default {
  name: 'Operlog',
  data () {
    return {
      choujiangquanState:[
      { choujiangquan_name: '停用', choujiangquan_state: '0' },
      { choujiangquan_name: '启用', choujiangquan_state: '1' },
      ],
      vipLevel: [
        { level_name: '全部等级', choujiangquan_level: '0' },
        { level_name: '会员1级及以上', choujiangquan_level: '1' },
        { level_name: '会员2级及以上', choujiangquan_level: '2' },
        { level_name: '会员3级及以上', choujiangquan_level: '3' },
        { level_name: '会员4级及以上', choujiangquan_level: '4' },
        { level_name: '会员5级及以上', choujiangquan_level: '5' },
        { level_name: '会员6级及以上', choujiangquan_level: '6' },

      ],
      fileList: [],
      limit: 2,
      baseURL: '',  //  图片上传地址
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,


      list: [],
      form: {
        choujiangquan_level:'0',
        choujiangquan_state:'0',
      },
      open: false,
      pageIndex: 1,
      pageSize: 10,
      // 禁用状态
      disabled: false,
      queryParams: {

      },
      loading: false,
      // table 列表数据
      list: [],
      // 总条数
      total: 0,

    }
  },

  created () {
    let flag = sessionStorage.getItem('login');
    if (!flag) {
      this.$router.push('/')
    }
    this.action = config.baseUrl + 'manageSystem/staticImageUpload';
    console.log(this.action)
    this.handleQuery();
  },
  methods: {
    //  可用等级
    levelTrans(row){
      
      let vipLevel = this.vipLevel;
      for(let i=0;i<vipLevel.length;i++){
        if(vipLevel[i].choujiangquan_level == row.choujiangquan_level){
          return vipLevel[i].level_name
        }
      }
    },
    //  可用等级
    discountTrans(row){
      
      return row.choujiangquan_discount +'%'
    },
      //  可用等级
      stateTrans(row){
      
      let choujiangquanState = this.choujiangquanState;
      for(let i=0;i<choujiangquanState.length;i++){
        if(choujiangquanState[i].choujiangquan_state == row.choujiangquan_state){
          return choujiangquanState[i].choujiangquan_name
        }
      }
    },
    handleUpdate (row) {
      this.open = true;
      this.form = row
    },
    handleDelete (row) {
      let params = {
        choujiangquan_id: row.choujiangquan_id,
      }
      
      this.$confirm('确认删除吗？')
        .then(() => {
          choujiangquanDelete(params).then(res => {
            this.$message.success('删除成功')
            this.handleQuery()
          })
        })
        .catch(_ => { });

    },
    submit () {
      console.log(this.form)

      let params = this.form;
      console.log(params)
      if (!params.choujiangquan_name) {
        return this.$message.error('请输入抽奖券名称')
      }
      if (!params.choujiangquan_desc) {
        return this.$message.error('请输入抽奖券描述')
      }
      if (!params.choujiangquan_num) {
        return this.$message.error('请输入抽奖券数量')
      }
      if (!params.choujiangquan_id) {
        choujiangquanAdd(this.form).then(res => {
          this.$message.success('新增成功')
          this.open = false
          this.handleQuery()
        })
      } else {
        choujiangquanUpdate(this.form).then(res => {
          this.$message.success('修改成功')
          console.log(res)
          this.open = false
          this.handleQuery()
        })
      }
    },

    // 曲调
    transIntro (row) {
      let list = this.intro
      for (let i = 0; i < list.length; i++) {
        if (list[i].prod_type == row.qumu_shuoming) {
          return list[i].label
        }
      }
    },

    //  退出
    logout () {
      localStorage.clear();
      this.$router.push('/')
    },
    // 新增按钮
    handleAdd () {
      this.open = true
      this.form = {
        choujiangquan_level:'0',
        choujiangquan_state:'0',
      }
    },
    // 查询按钮
    handleQuery () {
      let params = this.queryParams;
      params.pageIndex = this.pageIndex;
      params.pageSize = this.pageSize;

      this.list = []
      choujiangRecordList(params).then(res => {
        this.list = res.data.list;
        console.log(this.list)
        this.total = res.data.total
        console.log(this.total)
      })
    },

    //  上一页面
    preClick (e) {
      this.pageIndex = e;
      if (pageIndex <= 1) { return }
      this.handleQuery()
    },
    // 下一页
    preClick () {
      let pageIndex = this.pageIndex + 1;

      if (pageIndex * this.pageSize >= this.total) {
        return
      }
      this.pageIndex = pageIndex;
      this.handleQuery()
    },
    // 获取列表
    getList (e) {
      this.pageIndex = e
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }
      choujiangRecordList(params).then(res => {

        this.list = res.data.list;
        this.total = res.data.total
        console.log(this.total)
      })
    }
  }
}
</script>
<style>
.app-container {
  margin-top: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.gap {
  margin: 30px 10px;
}

.title {
  color: black;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.img {
  width: 50px;
  height: 50px;
  margin-left: 10px;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px !important;
}

.el-upload--picture-card {
  width: 100px;
  height: 100px !important;
  line-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/ChoujiangRecord.vue